const RESTRICTED_EMAIL_TYPES = [
  "vendor_verification",
  "promopinsa_offer"
];
export { RESTRICTED_EMAIL_TYPES };
